import { ContactForm } from './ContactForm';

/**
 * The last section on the page, and the only one that asks for anything.
 *
 * The layout changed shape when the form arrived. It used to be a wide pitch
 * beside a small card holding an email address, balanced `md:col-span-7` /
 * `md:col-span-5` — which was right when the right-hand column was one line of
 * text. A form is the taller element and the one people came here to use, so
 * the weight flips: the copy narrows and the form takes the larger half.
 *
 * `items-end` also had to go. It aligned the bottom of a short card to the
 * bottom of the heading; against a form six fields tall it would push the
 * heading down the page to meet it.
 *
 * The email address that used to sit underneath is gone. It was set in 3xl
 * display type and competed with the form for the same job, giving anyone
 * reluctant to fill one in an easy way not to — so the section asked for a
 * message twice and left it ambiguous which route actually reaches us. What
 * remains in that column is location and hours: context for the decision, not
 * a second way to make contact.
 */
export function Contact() {
  return (
    <section id="contact" className="border-line border-b">
      <div className="mx-auto max-w-6xl px-6 py-24 md:py-32">
        <div className="grid gap-12 md:grid-cols-12 md:gap-16">
          <div className="md:col-span-5">
            <p className="marketing-label text-clay">Contact</p>
            <h2 className="font-display mt-4 text-4xl leading-[1.12] md:text-5xl">
              Let&apos;s build something
              <br />
              <span className="text-rust italic">people remember.</span>
            </h2>
            <p className="text-clay mt-6 max-w-lg text-base leading-relaxed">
              We take on a small number of new partners each quarter. Tell us about the brand and
              we&apos;ll get back within two business days.
            </p>

            <div className="border-line mt-10 border-t pt-8">
              <p className="marketing-label text-clay">Where we are</p>
              <div className="text-clay mt-3 text-sm">
                <p>Based in Seattle, WA · Working globally</p>
                <p className="mt-1">Mon – Fri</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}
